import { isMoment } from "moment"
import { isoDate, isoformat } from "../constants"

export class Rechnungsverlauf {
    rechnungsdatum = isoDate
    rechnungsnummer = ""

    toJSON() {
        return {
            rechnungsdatum: this.rechnungsdatum && isMoment(this.rechnungsdatum) ? this.rechnungsdatum.format(isoformat) : null,
            rechnungsnummer: this.rechnungsnummer ? this.rechnungsnummer : null,
        }
    }
}
